<template>
  <div class="n2-pagina" ref="raiz">
    <N2CabezaPagina :titulo="titulo" :subtitulo="P.Subtitulo?.Texto" :imagen="P.Imagen" :filtro="P.ImagenFiltro"
      :boton="P.ShowButton ? P.Button : null" />

    <section class="n2-seccion n2-seccion--pagina">
      <div class="n2-contenedor">
        <!-- Panel: Diseño páginas → Blog → Banner desplegable -->
        <BlogBannerCollapsible v-if="P.Banner?.Mostrar" :banner="P.Banner" class="n2-banner-blog" />

        <div v-if="publicados.length" class="n2-barra-lista">
          <N2Buscador v-if="P.MostrarBuscador !== false" v-model="busqueda" :placeholder="tSolicitud('Buscar')" :sin-resultados="!ordenados.length" />
          <button type="button" class="n2-boton n2-boton--linea n2-barra-lista__orden" @click="recientes = !recientes">
            <v-icon size="18">{{ recientes ? 'mdi-sort-clock-descending-outline' : 'mdi-sort-clock-ascending-outline' }}</v-icon>
            {{ $t('ordenar') }}: {{ recientes ? $t('masRecientesPrimero') : $t('masAntiguosPrimero') }}
          </button>
        </div>

        <N2ListaArticulos :articulos="ordenados.slice(0, visibles)" :columnas="columnas" :class="{ 'n2-lista--destacado': recientes && !busqueda.trim() && ordenados.length > 3 }" />

        <div v-if="ordenados.length > visibles" class="n2-centrado">
          <button type="button" class="n2-boton n2-boton--linea" @click="visibles += 6">{{ $t('verMas') }}</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useStore } from '../../store/index'
import { useUtils } from '#imports'
import { t as tSolicitud } from '../../composables/solicitudTextos'
import { tituloSeccion, textoPlano, fechaNotin, columnasPanel, useAparicion } from '../../composables/useNotaria2'
import BlogBannerCollapsible from '../blog/BlogBannerCollapsible.vue'
import N2CabezaPagina from './N2CabezaPagina.vue'
import N2Buscador from './N2Buscador.vue'
import N2ListaArticulos from './N2ListaArticulos.vue'

const store = useStore()
const { NOTARIA } = storeToRefs(store)
const { $t } = useUtils()
const raiz = ref(null)
useAparicion(raiz)

// Panel: Diseño páginas → Blog (cabecera, banner, buscador y columnas) y los artículos publicados
const P = computed(() => NOTARIA.value?.Theme?.Blog ?? {})
const titulo = computed(() => P.value.Titulo?.Texto || tituloSeccion(NOTARIA.value, 'Blog', $t))
const columnas = computed(() => columnasPanel(P.value.NumeroColumnas))

const publicados = computed(() => (NOTARIA.value?.Blog ?? []).filter(a => a.Publicado))
const busqueda = ref('')
const recientes = ref(true)
const visibles = ref(9)
const ordenados = computed(() => {
  const q = busqueda.value.trim().toLowerCase()
  const lista = q
    ? publicados.value.filter(a => [a.Titulo, a.Extracto, textoPlano(a.Contenido), ...(a.Categorias ?? [])].some(t => String(t || '').toLowerCase().includes(q)))
    : [...publicados.value]
  return lista.sort((a, b) => (recientes.value ? -1 : 1) * (fechaNotin(a.Fecha) - fechaNotin(b.Fecha)))
})
</script>
